import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { selectUserResult } from 'selectors';
import * as actions from 'actions';

import { NavLink } from 'react-router-dom';

const TEXT = 'Results';

class ResultsLink extends PureComponent {
  render() {
    const { currentUserResult } = this.props;
    if (currentUserResult.status === 'ready') {
      return (
        <NavLink
          exact
          className="Header-navigation-item"
          to={`/results/${currentUserResult.uuid}`}
        >
          {TEXT}
        </NavLink>
      );
    } else {
      return <span className="Header-navigation-item disabled">{TEXT}</span>;
    }
  }
}

function mapStateToProps(state) {
  return {
    currentUserResult: selectUserResult(state),
    currentUserId: state.auth.currentUserId,
    // make sure this component updates when the current result changes
    currentResult: state.currentResult,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getResult: actions.getResult,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultsLink);



// WEBPACK FOOTER //
// ./src/Components/Layout/ResultsLink.js